import React from 'react';
import { MuiTelInput } from 'mui-tel-input';

const PhoneNumberField = ({
  value,
  setPhoneNumber,
  disabled,
  code,
  setCode,
  country,
  setCountry,
}) => {
  const formattedValue = value?.startsWith(code) ? value : `${code}${value}`;

  const handleChange = (newValue, info) => {
    if (!info) return;

    const { countryCode, nationalNumber, countryCallingCode } = info;

    setPhoneNumber(nationalNumber);  // Store only the number, without country code
    setCode(`+${countryCallingCode}`); // Store country code separately
    setCountry && setCountry(countryCode);  // Store country ISO code
  };

  return (
    <div className="w-full mt-2">
      <MuiTelInput
        value={formattedValue}
        onChange={handleChange}
        disabled={disabled}
        defaultCountry={country || 'US'}
        forceCallingCode
        focusOnSelectCountry
        className="w-full"
        sx={{
          width: '100%',
          input: {
            padding: '6px 5px',
            fontSize: '14px',
            height: '28px',
          },
          '& .MuiInputBase-root': {
            borderRadius: '10px !important',
            borderColor: 'transparent !important',
          },
          '& .MuiInputAdornment-root': { marginRight: '8px' },
          '& .MuiTelInput-input': { paddingRight: '30px' },
          '& .MuiTelInput-FlagImg': {
            borderRadius: '50% !important', // Ensure the flag is round
            overflow: 'hidden',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          background: '#FFF',
          border: '1px solid #D5D7DA',
          boxShadow: '0px 1px 2px 0px #0A0D120D',
          borderRadius: '0.75rem',
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          '& .MuiOutlinedInput-root.Mui-focused': {
            boxShadow: '0 0 0 1px #E72848',
          },
          "&:hover": {
            boxShadow: "0 0 0 1px #E72848",
            borderColor: "transparent"
          }
        }}
      />
    </div>
  );
};

export default PhoneNumberField;
